import State from '../core/State';
import { SingleDirectorUserFragment } from '../generated/graphql';

export const startAuthentication = () => (state: State): State => ({
  ...state,
  authentication: {
    ...state.authentication,
    fetching: state.authentication.fetching + 1,
  },
});

export const finishAuthentication = () => (state: State): State => ({
  ...state,
  authentication: {
    ...state.authentication,
    fetching: state.authentication.fetching - 1,
  },
});

export const setSignedInUser = (user: SingleDirectorUserFragment) => (state: State): State => ({
  ...state,
  authentication: {
    ...state.authentication,
    signedInUser: user,
  },
});

export const disposeUser = () => (state: State): State => ({
  ...state,
  authentication: {
    ...state.authentication,
    signedInUser: null,
  },
});
